<template>
    <div class="text-1xl">
        <router-link v-bind:to="subItem.router">
            <the-language :de="subItem.title_de" :en="subItem.title_en" />
        </router-link>
    </div>
</template>

<script>
    import { serverBus } from '../../main';
    import TheLanguage from "../TheLanguage";

    export default {
        name: 'TheSubNav',
        components: {
            TheLanguage
        },
        data() {
            return {}
        },
        props: {
            subItem: {
                type: Object,
                default: () => {
                }
            }
        },
        methods: {
            navshowFct() {
                serverBus.$emit('shownav', false);
            }
        }
    }

</script>
